export function videoStreamRender() { return `<div id="video-stream-view" class="video-stream-view">
    <div class="call-container">
        <div class="chat-notification-block hide" title="Click here to see chat" ld--elist="click" ld-on-click="showChatView">
            <span class="chat-notification-badge">
                <span class="chat-notification-count"></span>
            </span>
        </div>
        <div class="video-call">
            <div class="remote-video-container">
                <div class="video-no-agent-video">
                    <div class="agent-alias-container center-align-item">
                        <div class="agent-alias-outer-div center-align-item">
                            <div class="agent-alias-inner-div center-align-item">
                                <div class="agent-alias-inner-most-div center-align-item">
                                    <div class="agent-alias-text center-align-item">${ this.agentAliasText }</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="video-expand-icon-block hide">
                    <button title="Expand video view" class="video-expand-icon" ld--elist="click" ld-on-click="expandVideoContainer"></button>
                </div>
            </div>
            <div class="local-video-container">
                <div class="video-no-customer-video">
                    <div>
                        <img class="noCustomerVideoImg" src="${ this.noCustomerVideoImg }">
                    </div>
                </div>
            </div>
            <div class="call-transfer-text hide">
                <span class="call_transfer_loader"></span>
                <span>${ this.callTransferText }</span>
            </div>
            <div class="video-chat-controls">
                <button title="Device settings" class="settings-icon" ld--elist="click" ld-on-click="showDeviceSettings"></button>
                ${ this.showCustomerCamera ? `<button title="Turn off camera" class="video-on-icon" ld--elist="click" ld-on-click="toggleVideoOnOff"></button>`:`` }
                ${ this.showCustomerCamera ? `<button title="Turn on camera" class="video-off-icon hide" ld--elist="click" ld-on-click="toggleVideoOnOff"></button>`:`` }
                <button title="Turn off microphone" class="mic-on-icon" ld--elist="click" ld-on-click="toggleMicrophoneOnOff"></button>
                <button title="Turn on microphone" class="mic-off-icon hide" ld--elist="click" ld-on-click="toggleMicrophoneOnOff"></button>
                <button title="End call" class="end-call-icon" ld--elist="click" ld-on-click="endCall"></button>
            </div>
        </div>
        <div class="call-connecting">
            <div class="call_loader_top"></div>
            <div class="call_connecting_text">
                <h3>${ this.connectingText }</h3>
            </div>
            <div class="call_loader_bottom"></div>
            <div class="call-connecting-footer">
                <button ld--elist="click" ld-on-click="endCall">${ this.endCallButtonText }</button>
            </div>
        </div>
        <div class="call-error">
            <div>
                <div class="card">
                    <p class="text">${ this.callErrorText }</p>
                    <div class="call-error-footer">
                       <button ld--elist="click" ld-on-click="endCall">${ this.endCallButtonText }</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="unsupported-device-error">
            <div>
                <div class="card">
                    <p class="text">${ this.unsupportedDeviceErrorText }</p>
                    <div class="call-error-footer">
                       <button ld--elist="click" ld-on-click="switchToCallView">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="media-settings-container">
            ${ this.showCustomerCamera ? `<div id="videoSourceSettings">
                <label for="videoDevices">Camera </label>
                <select id="videoDevices"></select>
            </div>`:`` }
            <div>
                <label for="inputDevices">Microphone </label>
                <select id="inputDevices"></select>
            </div>
            <div>
                <label for="outputDevices">Speaker </label>
                <select id="outputDevices"></select>
            </div>
            <div class="speaker-volume-container">
                <img src="${ this.speakerMuteImg }" role="button" ld--elist="click" ld-on-click="muteVolume">
                <input id="vol-control" type="range" min="0" max="100" step="1" ld--elist="change,input" ld-on-change="setVolume" ld-on-input="setVolume">
                <img src="${
                    this.speakerVolumeImg
                }" ld--elist="click" ld-on-click="unmuteVolume">
            </div>
            <div class="media-settings-footer card-container">
                <button ld--elist="click" ld-on-click="hideDeviceSettings">Close</button>
            </div>
        </div>
    </div>
</div>`  }